export default function CotizadorIcon({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 10 16" fill="none">
      <path
        d="M5 0.962494V14.7125"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 3.46249H3.1875C2.60734 3.46249 2.05094 3.69296 1.6407 4.1032C1.23047 4.51343 1 5.06983 1 5.64999C1 6.23015 1.23047 6.78655 1.6407 7.19679C2.05094 7.60703 2.60734 7.83749 3.1875 7.83749H6.3125C6.89266 7.83749 7.44906 8.06796 7.8593 8.4782C8.26953 8.88843 8.5 9.44483 8.5 10.025C8.5 10.6052 8.26953 11.1616 7.8593 11.5718C7.44906 11.982 6.89266 12.2125 6.3125 12.2125H1"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
